<a
	@fadeIn
	mat-list-item
	class="nav-item nav-list-item"
	[routerLink]="path"
	[routerLinkActive]="path ? 'active' : ''"
	[routerLinkActiveOptions]="{ exact: true }"
	(click)="layoutFacade.closeSidenav(); navigate.emit()"
>
	<bp-svg-icon *ngIf="icon" matListIcon [name]="icon"> </bp-svg-icon>

	<span mat-line>
		<ng-content></ng-content>
	</span>
</a>
